interface ChildItem {
  actual_value?: string
  id: string | null
  label: string
  name: string | null
  original_name?: string
  original_number?: string
  value: string
}

interface ExtendedChildItem extends ChildItem {
  formatted_text: string
  text: string
}

type ParentItem<A> = {
  text: string
  children: Array<A>
}

type ReturnType<A> = A extends ChildItem
  ? ExtendedChildItem
  : A extends ParentItem<ChildItem>
  ? ParentItem<ExtendedChildItem>
  : never

function isParentItem(
  item: ChildItem | ParentItem<ChildItem> | Record<string, unknown>
): item is ParentItem<ChildItem> {
  return (
    (item as ParentItem<ChildItem>).text !== undefined &&
    (item as ParentItem<ChildItem>).children !== undefined
  )
}

const formatAccountsForSelect2 = function (
  item: ChildItem | ParentItem<ChildItem>
): ReturnType<typeof item> {
  if (isParentItem(item)) {
    const children = item.children.map(
      formatAccountsForSelect2
    ) as ExtendedChildItem[]

    return {
      text: item.text,
      children: children,
    }
  } else {
    let number = ''

    if (item.original_number) {
      number += `${item.original_number} `
    }

    if (item.original_name) {
      number += `${item.original_name} `
    }

    return {
      ...item,
      formatted_text: `${item.label} <span class="muted">${number}</span>`,
      text: item.label,
      id: item.value,
    }
  }
}

// Making it global because it is reused from both sprockets and webpacker javascript
// Remove this when sprockets code is migrated to webpacker
window.formatAccountsForSelect2 = formatAccountsForSelect2

export default formatAccountsForSelect2
